// Holds the CSRF token and a minimal session snapshot in memory (not localStorage:
// the session itself lives in an httpOnly cookie; only the CSRF token needs a JS-visible home).
import type { MeResponse } from './types';

type Listener = () => void;

interface SessionState {
  csrfToken: string | null;
  me: MeResponse | null;
}

let state: SessionState = { csrfToken: null, me: null };
const listeners = new Set<Listener>();

export function getSession(): SessionState {
  return state;
}

export function setSession(next: Partial<SessionState>): void {
  state = { ...state, ...next };
  for (const l of listeners) l();
}

export function clearSession(): void {
  state = { csrfToken: null, me: null };
  for (const l of listeners) l();
}

export function subscribeSession(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
